export default {
      id: "epro-info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#epro-info",
      toString: function () {
        return this.url;
      }
    }